import { CellClassParams } from 'ag-grid-community';
import { get } from 'lodash';

const getListGridRowCellClassForGroup = (
  isAutoRestock = false,
): Record<string, (params: CellClassParams) => boolean> => {
  return {
    'xvi-changed-row': (params): boolean => {
      return get(params, 'data.isChanged', false);
    },
    'row-unselective': (params): boolean => {
      return isAutoRestock && get(params, 'data.disabled', false);
    },
  };
};

export { getListGridRowCellClassForGroup };
